import React from 'react';
import { FaGoogle } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Cookies } from './../index.js';

function LoginHomeProcess({ lang, first_data_home_1, first_data_home_2 }) {
    const navigate = useNavigate();
    const latest_version = useSelector(state => state.latest_version);
    const switch_router = (link) => navigate(link);
    const main_domain = Cookies.get("main_domain");
    const baseButtonClass =
        "group relative isolate overflow-hidden mx-2 mb-2 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full font-bold tracking-wide text-[#0b1730] backdrop-blur-xl bg-white/26 border border-white/72 shadow-[0_12px_30px_rgba(15,23,42,0.16),inset_0_1px_0_rgba(255,255,255,0.78),inset_0_-1px_0_rgba(255,255,255,0.3)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-white/34 hover:border-white/85 hover:shadow-[0_18px_40px_rgba(15,23,42,0.24),inset_0_1px_0_rgba(255,255,255,0.9),inset_0_-1px_0_rgba(255,255,255,0.36)] active:translate-y-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/95";
    const tintLayerClass =
        "pointer-events-none absolute inset-[1px] rounded-full opacity-100";
    const frostLayerClass =
        "pointer-events-none absolute inset-[1px] rounded-full bg-[linear-gradient(180deg,rgba(255,255,255,0.26)_0%,rgba(255,255,255,0.08)_48%,rgba(255,255,255,0.18)_100%)]";
    const sweepLayerClass =
        "pointer-events-none absolute inset-0 translate-x-[-125%] bg-[linear-gradient(115deg,transparent_20%,rgba(255,255,255,0.38)_50%,transparent_80%)] transition-transform duration-700 group-hover:translate-x-[125%]";
    const edgeLayerClass =
        "pointer-events-none absolute inset-0 rounded-full shadow-[inset_0_1px_0_rgba(255,255,255,0.9),inset_0_-1px_0_rgba(255,255,255,0.36)]";
    const textLayerClass =
        "relative z-10 drop-shadow-[0_1px_1px_rgba(255,255,255,0.5)]";
    const homeText1 = first_data_home_1?.[lang] || first_data_home_1?.en || {};
    const homeText2 = first_data_home_2?.[lang] || first_data_home_2?.en || {};

    const openGooglelogin = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.includes("hustmedia-android")) {
            window.location.href = '/reactapp/selectgoogle';
        } else {
            window.location.href = '/shop/auth/login_google?app=uiviewcontroller';
        }
    };
    return (
        <>
            {((latest_version == 3) && main_domain == 'hust') ? (
                <>
                    <button
                        onClick={() => switch_router("/ai/utility/home_ai")}
                        className={baseButtonClass}
                    >
                        <span className={`${tintLayerClass} bg-[linear-gradient(125deg,rgba(167,139,250,0.52)_0%,rgba(129,140,248,0.44)_52%,rgba(96,165,250,0.38)_100%)]`} />
                        <span className={frostLayerClass} />
                        <span className={sweepLayerClass} />
                        <span className={edgeLayerClass} />
                        <span className={textLayerClass}>{homeText2.textToSpeech}</span>
                    </button>

                    <button
                        onClick={() => switch_router("/ai/orders_once/speech_text")}
                        className={baseButtonClass}
                    >
                        <span className={`${tintLayerClass} bg-[linear-gradient(125deg,rgba(251,191,36,0.5)_0%,rgba(251,146,60,0.42)_50%,rgba(244,114,182,0.34)_100%)]`} />
                        <span className={frostLayerClass} />
                        <span className={sweepLayerClass} />
                        <span className={edgeLayerClass} />
                        <span className={textLayerClass}>{homeText2.speechToText}</span>
                    </button>

                    <button
                        onClick={() => switch_router("/ai/orders_once/image_text")}
                        className={baseButtonClass}
                    >
                        <span className={`${tintLayerClass} bg-[linear-gradient(125deg,rgba(125,211,252,0.5)_0%,rgba(96,165,250,0.42)_50%,rgba(129,140,248,0.36)_100%)]`} />
                        <span className={frostLayerClass} />
                        <span className={sweepLayerClass} />
                        <span className={edgeLayerClass} />
                        <span className={textLayerClass}>{homeText2.imageToText}</span>
                    </button>
                </>
            ) : (
                <>
                    {/* Đăng ký bảo mật */}
                    <button
                        onClick={() => switch_router("/shop/auth/signupusername")}
                        className={baseButtonClass}
                    >
                        <span className={`${tintLayerClass} bg-[linear-gradient(125deg,rgba(192,132,252,0.52)_0%,rgba(129,140,248,0.42)_50%,rgba(96,165,250,0.35)_100%)]`} />
                        <span className={frostLayerClass} />
                        <span className={sweepLayerClass} />
                        <span className={edgeLayerClass} />
                        <span className={textLayerClass}>{homeText1.signupUsername}</span>
                    </button>

                    {/* Đăng ký nhanh */}
                    <button
                        onClick={() => switch_router("/reactapp/singup")}
                        className={baseButtonClass}
                    >
                        <span className={`${tintLayerClass} bg-[linear-gradient(125deg,rgba(251,191,36,0.54)_0%,rgba(251,146,60,0.44)_54%,rgba(244,114,182,0.36)_100%)]`} />
                        <span className={frostLayerClass} />
                        <span className={sweepLayerClass} />
                        <span className={edgeLayerClass} />
                        <span className={textLayerClass}>{homeText1.fastSignup}</span>
                    </button>

                    {/* Đăng nhập */}
                    <button
                        onClick={() => switch_router("/reactapp/auth/loginusername")}
                        className={baseButtonClass}
                    >
                        <span className={`${tintLayerClass} bg-[linear-gradient(125deg,rgba(125,211,252,0.52)_0%,rgba(96,165,250,0.44)_52%,rgba(129,140,248,0.36)_100%)]`} />
                        <span className={frostLayerClass} />
                        <span className={sweepLayerClass} />
                        <span className={edgeLayerClass} />
                        <span className={textLayerClass}>{homeText1.signIn}</span>
                    </button>

                    {/* Đăng nhập Google */}
                    <button
                        onClick={openGooglelogin}
                        className={baseButtonClass}
                    >
                        <span className={`${tintLayerClass} bg-[linear-gradient(125deg,rgba(110,231,183,0.5)_0%,rgba(94,234,212,0.42)_50%,rgba(125,211,252,0.34)_100%)]`} />
                        <span className={frostLayerClass} />
                        <span className={sweepLayerClass} />
                        <span className={edgeLayerClass} />
                        <div className={`${textLayerClass} flex items-center`}>
                            <div>{homeText1.signInWithGoogle}</div>
                            <FaGoogle className="ml-2 text-[#0b1730] drop-shadow-[0_1px_1px_rgba(255,255,255,0.5)]" size={12} />
                        </div>
                    </button>

                    {/* Đăng nhập Telegram */}
                    <button
                        onClick={() => switch_router("/reactapp/auth/telegram")}
                        className={baseButtonClass}
                    >
                        <span className={`${tintLayerClass} bg-[linear-gradient(125deg,rgba(129,140,248,0.52)_0%,rgba(167,139,250,0.42)_50%,rgba(244,114,182,0.34)_100%)]`} />
                        <span className={frostLayerClass} />
                        <span className={sweepLayerClass} />
                        <span className={edgeLayerClass} />
                        <span className={textLayerClass}>{homeText1.signInWithTelegram}</span>
                    </button>
                </>
            )}
        </>
    );
}

export default LoginHomeProcess;
